import { render, staticRenderFns } from "./OpenMahnungen.vue?vue&type=template&id=4b417ae0&scoped=true"
import script from "./OpenMahnungen.vue?vue&type=script&lang=ts"
export * from "./OpenMahnungen.vue?vue&type=script&lang=ts"
import style0 from "./OpenMahnungen.vue?vue&type=style&index=0&id=4b417ae0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b417ae0",
  null
  
)

export default component.exports